
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './verifiedemail.scss';






const Pverifiedemail = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  
  
  

  
  return (
    <div id="id656772f58d2e0931f97bdecb" >

      <div id="fgfg" className="">
      
      <div id="i99szh" className="">
      
        <a
          target=""
          className=""
          id="i9ymbj"
          href="#"
        >
          
      <img
        className=""
        id="i1d1f1"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr0oo7y.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="ix5d2" className="">
      
      <div id="iw403" className="">
      
      <div className="" id="iegvfq">
        <>¡Correo verificado exitosamente!</>
      </div>
      
      <div className="" id="ibc69">
        <>Te damos una cordial bienvenida y esperamos tengas una experiencia exitosa y fructífera dentro de nuestra plataforma.</>
      <br className="" id="" />
      <>¡Haz click en el siguiente botón para comenzar!</>
      </div>
      
      <div id="ikf7l" className="">
      
        <a
          target=""
          className="buttoniniciosesion "
          id="i6z1y"
          href="/signin"
        >
          
    <div id="igrxm" className="">
    <>Iniciar Sesión</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pverifiedemail);
  